import { action, computed, observable } from 'mobx';
import { AppThemeConfig } from '../types/app.types';
import { TestimonialItem } from '../types/testimonials.types';
import { NON_GAME_PRODUCT_BY_THEME } from '../types/product';
import type {
  GameRegistryItemI,
  GameRegistryResult,
} from '../components/dynamic-modules/game-registry/game-registry.types';

export class ConfigStore {
  @observable config: AppThemeConfig | null = null;
  @observable gameRegistry: GameRegistryResult | null = null;

  constructor(readonly theme: string) {}

  @action
  setGameRegistry = (gameRegistry: GameRegistryResult | null) => {
    this.gameRegistry = gameRegistry;
  };

  @action
  setConfig = (config: AppThemeConfig) => {
    this.config = config;
  };

  @computed
  get gameRegistryItem(): GameRegistryItemI | null {
    return this.gameRegistry?.gameDictBySlug[this.theme] ?? null;
  }

  @computed
  get productAbbreviation(): string | null {
    return NON_GAME_PRODUCT_BY_THEME[this.theme] ?? this.gameRegistryItem?.gameAbbreviation ?? null;
  }

  @computed
  get gameName(): string | null {
    return this.gameRegistryItem?.gameName ?? null;
  }

  @computed
  get wallpaper(): string | null {
    return this.config ? this.config.wallpaper : null;
  }

  @computed
  get paymentWallpaper(): string {
    return this.config?.paymentWallpaper!;
  }

  @computed
  get paymentCongratulationWallpaper(): string {
    return this.config?.paymentCongratulationWallpaper!;
  }

  @computed
  get redirectUri(): string | null {
    return this.config ? this.config.fallbackRedirectUri : null;
  }

  @computed
  get testimonials(): TestimonialItem[] | null {
    return this.config ? this.config.testimonials : null;
  }

  @computed
  get errorWallpaper(): string | null {
    return this.config ? this.config.errorWallpaper || this.config.wallpaper : null;
  }

  @computed
  get isPremiumSubscriptionAvailable() {
    return this.config?.isPremiumSubscriptionAvailable ?? null;
  }
}
